/**
 * Throws if `n` is not a finite, strictly-positive integer. Used by callback
 * builders that pass `n` into `BigInt(...)` — surfacing the friendly message
 * here keeps callers from seeing the bare `RangeError: ... not an integer`
 * that `BigInt(1.5)` produces.
 */
export function assertPositiveInteger(n: number, label: string): void {
  if (!Number.isInteger(n) || n < 1) {
    throw new Error(`[${label}] n must be a positive integer, got ${n}`)
  }
}
